var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgJumpForward = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 122.35 103.09",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-miterlimit:10;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "design"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118,79.67a1.91,1.91,0,0,1-1.53-.77L98.24,54.12,73.31,70.67a1.89,1.89,0,0,1-2.09-3.15L97.65,50a1.88,1.88,0,0,1,2.57.46l19.26,26.23a1.9,1.9,0,0,1-.4,2.65A1.94,1.94,0,0,1,118,79.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.54,100.59a49,49,0,0,1,0-98.09,1.89,1.89,0,1,1,0,3.78A45.27,45.27,0,1,0,96.81,51.54a1.89,1.89,0,0,1,3.78,0A49.1,49.1,0,0,1,51.54,100.59Z"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgJumpForward, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/jump_forward.fcbfd718.svg";
export { ForwardRef as ReactComponent };